import {
  Home,
  PermMedia,
  Link as LinkIcon,
  Event,
  Subject,
  ListAlt,
} from '@material-ui/icons';

const nav = [
  { title: 'Home', link: '/home', icon: Home },
  { title: 'Events', link: '/events', icon: Event },
  { title: 'Media', link: '/media', icon: PermMedia },
  { title: 'Programs', link: '/programs/studio-classes', icon: ListAlt },
  { title: 'Subjects', link: '/subjects', icon: Subject },
  { title: 'Links', link: '/links', icon: LinkIcon },
];

export default nav;
